export default class BroadcastChannelActionEnum {
    static Logout = new BroadcastChannelActionEnum("ESESJA_LOGOUT", "Nastąpiło wylogowanie")
    static Login = new BroadcastChannelActionEnum("ESESJA_LOGIN", "Zalogowano");

    constructor(label, description){
        this.label = label
        this.description = description;
    }
}